import { Alert, Divider, Grid, Typography } from '@mui/material'
import { useLoadOrderClientOverduePayments } from 'modules/orders/hooks'
import { Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import { formatCurrency, formatDate } from 'utils'

export const OverDues = () => {
  const { watch } = useFormContext()

  const [customer] = watch(['customer'])

  const { data: orderClientOverdue } = useLoadOrderClientOverduePayments({
    customerId: customer?.id
  })
  const hasOverDues = !!orderClientOverdue?.data?.length
  return (
    <div style={{ height: 300, overflowX: 'auto' }}>
      {!hasOverDues && <Alert severity="info">Não há dados!</Alert>}
      {orderClientOverdue?.data.map((customer: any) => {
        return (
          <Fragment key={customer?.id}>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <Typography variant="caption" gutterBottom>
                  Nota Fiscal
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                  {customer?.invoice || 0}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="caption" gutterBottom>
                  Valor NF
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                  {formatCurrency(customer?.totalValue || 0)}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" gutterBottom>
                  Data Vencimento
                </Typography>
                <Typography style={{ fontSize: 14, fontWeight: 500 }}>
                  {formatDate(customer?.dueDate || '')}
                </Typography>
              </Grid>
            </Grid>
            <Divider
              sx={{
                marginTop: 1,
                marginBottom: 1
              }}
            />
          </Fragment>
        )
      })}
    </div>
  )
}
